import privileges from './privileges';

export const MODULES_PRIVILEGES = {
  [privileges.ADD_EMPLOYEE]: 'employees',
  [privileges.DELETE_EMPLOYEE]: 'employees',
  [privileges.EDIT_HR]: 'employees',
  [privileges.COMMUNICATION]: 'communication',
  [privileges.FEED]: 'communication',
  [privileges.CRM]: 'crm',
  [privileges.DIRECTORY]: 'directory',
  [privileges.ATS]: 'ats',
  [privileges.ATS_CREATE_OPENINGS]: 'ats',
  [privileges.SCHEDULING]: 'scheduling',
  [privileges.EDIT_SCHEDULING]: 'scheduling',
  [privileges.MANAGE_MAIN_PROJECTS]: 'scheduling',
  [privileges.ASSIGN_EVENTS_TO_MAIN_PROJECT]: 'scheduling',
  [privileges.TIMESHEET]: 'timesheet',
  [privileges.SEQUENCE]: 'sequences',
  [privileges.EDIT_AND_CREATE_SEQUENCE]: 'sequences',
  [privileges.SHIFT_TASKS]: 'communication',
  [privileges.EDIT_AND_CREATE_SHIFT_TASKS]: 'communication',
  [privileges.COMPLIANCE]: 'compliance',
  [privileges.PAYROLL]: 'payroll',
  [privileges.INVOICE]: 'invoice',
  [privileges.SUPPLIERS]: 'suppliers',
  [privileges.APPROVE_TIMESHEET]: 'timesheet',
  [privileges.KIOSK_TABLET]: 'timesheet',
  [privileges.UNLOCK_PAYROLL]: 'payroll',
  [privileges.EXPORT_PROCESS_PAYROLL]: 'payroll',
  [privileges.EDIT_PAYROLL_FIELDS_ON_TIMESHEETS]: 'timesheet'
};

// Removes privileges if not has the correct module
const joinPrivilegesWithModules = (mappedPrivileges, modules) =>
  Object.entries(mappedPrivileges).reduce(
    (prev, [key, value]) => ({
      ...prev,
      [key]: !MODULES_PRIVILEGES[key] || modules[MODULES_PRIVILEGES[key]] ? value : false
    }),
    {}
  );

export default joinPrivilegesWithModules;
